/* istanbul ignore file */

import { css } from 'styled-components';

import 'focus-visible';
import { fontFace } from './fonts';
import { palette } from './palette';
import type { Theme } from 'client-ribbons-base/types/theme';

export const JS_FOCUS_VISIBLE_CLASS = 'js-focus-visible';

export const fontFaces = ({ fonts }: Theme) => css`
  ${fontFace(fonts.PRIMARY_REGULAR)}
  ${fontFace(fonts.PRIMARY_SEMIBOLD)}
`;

export const paletteCssVariables = css`
  :root {
    --brand-purple-base-high-contrast: ${palette.primary.purpleBaseHighContrast};
    --brand-purple-base: ${palette.primary.purpleBase};
    --brand-purple-70: ${palette.primary.purple70};
    --brand-purple-50: ${palette.primary.purple50};
    --brand-purple-30: ${palette.primary.purple30};
    --brand-purple-10: ${palette.primary.purple10};
    --brand-purple-5: ${palette.primary.purple5};
    --brand-bluple-base: ${palette.secondary.blupleBase};
    --brand-bluple-70: ${palette.secondary.bluple70};
    --brand-bluple-50: ${palette.secondary.bluple50};
    --brand-bluple-30: ${palette.secondary.bluple30};
    --brand-bluple-10: ${palette.secondary.bluple10};
    --tertiary-pink-base: ${palette.tertiary.pinkBase};
    --tertiary-pink-50: ${palette.tertiary.pink50};
    --tertiary-pink-30: ${palette.tertiary.pink30};
    --tertiary-pink-10: ${palette.tertiary.pink10};
    --tertiary-blue-base: ${palette.tertiary.blueBase};
    --tertiary-blue-50: ${palette.tertiary.blue50};
    --tertiary-blue-30: ${palette.tertiary.blue30};
    --tertiary-blue-10: ${palette.tertiary.blue10};
    --tertiary-coral-base: ${palette.tertiary.coralBase};
    --tertiary-coral-50: ${palette.tertiary.coral50};
    --tertiary-coral-30: ${palette.tertiary.coral30};
    --tertiary-coral-10: ${palette.tertiary.coral10};
    --tertiary-green-base: ${palette.tertiary.greenBase};
    --tertiary-green-50: ${palette.tertiary.green50};
    --tertiary-green-30: ${palette.tertiary.green30};
    --tertiary-green-10: ${palette.tertiary.green10};
    --tertiary-yellow-base: ${palette.tertiary.yellowBase};
    --tertiary-yellow-50: ${palette.tertiary.yellow50};
    --tertiary-yellow-30: ${palette.tertiary.yellow30};
    --tertiary-yellow-10: ${palette.tertiary.yellow10};
    --tertiary-red-base: ${palette.tertiary.redBase};
    --tertiary-red-50: ${palette.tertiary.red50};
    --tertiary-red-30: ${palette.tertiary.red30};
    --tertiary-red-10: ${palette.tertiary.red10};
    --functional-green-deep: ${palette.functional.greenDeep};
    --functional-green-base: ${palette.functional.greenBase};
    --functional-green-50: ${palette.functional.green50};
    --functional-green-30: ${palette.functional.green30};
    --functional-green-10: ${palette.functional.green10};
    --functional-yellow-base: ${palette.functional.yellowBase};
    --functional-yellow-50: ${palette.functional.yellow50};
    --functional-yellow-30: ${palette.functional.yellow30};
    --functional-yellow-10: ${palette.functional.yellow10};
    --functional-red-base: ${palette.functional.redBase};
    --functional-red-50: ${palette.functional.red50};
    --functional-red-30: ${palette.functional.red30};
    --functional-red-10: ${palette.functional.red10};
    --neutral-black-base: ${palette.neutral.blackBase};
    --neutral-black-70: ${palette.neutral.black70};
    --neutral-black-40: ${palette.neutral.black40};
    --neutral-black-30: ${palette.neutral.black30};
    --neutral-black-10: ${palette.neutral.black10};
    --neutral-white-base: ${palette.neutral.white};
  }
`;
